import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../AbstractElements'
import HomeTestProfileList from './HomeTestProfileList'
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";


export default function TestProfileList() {
  return (
    <Fragment>
      <Breadcrumbs mainTitle="List Of Lab Report Test Profile" parent="Home" title="List Of Lab Report Test Profile" />
      <Container fluid={true}>
        <Row>
          <Col className="h-100">
            <HomeTestProfileList />
          </Col>
        </Row>
      </Container>    
    </Fragment>
  )
}
